import React from "react";
import { Link } from "gatsby";
import WidgetContainer from "components/WidgetContainer/WidgetContainer";

import "./BusinessSolutionTabWidget.css";

const BusinessSolutionTabWidget = () => {
    return (
        <WidgetContainer>
            <div className="bs-tab-widget">
                <a className="bs-tab-widget__item">I want to :</a>

                <a
                    href="#switch-section"
                    className="bs-tab-widget__item bs-border-line"
                >
                    Be on PhonePe Switch
                </a>

                <a
                    href="#cashless-business"
                    className="bs-tab-widget__item bs-border-line"
                >
                    Accept payments at stores
                </a>
                <a
                    href="#secure-pay"
                    className="bs-tab-widget__item bs-border-line"
                >
                    Accept online payments
                </a>
                <a
                    href="#advertise-business-faster"
                    className="bs-tab-widget__item"
                >
                    Advertise on PhonePe
                </a>
            </div>
        </WidgetContainer>
    );
};

export default BusinessSolutionTabWidget;
